import React, {Component} from 'react';
import {connect} from 'react-redux';
import { NavLink, withRouter} from 'react-router-dom';
import ReactTable from 'react-table';
import 'react-table/react-table.css'
class UserOverview extends Component {
    constructor(props) {
        super(props);
        this.columns = [{
              Header: 'Naam',
              accessor: 'name'
        },{
              Header: 'Email',
              accessor: 'email',
        },{
              Header: 'Telefoon',
              accessor: 'telephone',
        },
        {
            Header: 'Bewerken',
            accessor: 'name',
            Cell: props => <span><NavLink to={'/mijn-gebruikers/wijzigen/'+props.row._index} style={{display : 'inline'}} className="nav-link">Gebruiker updaten</NavLink></span>
        }]
    }

    componentDidMount() {
        document.querySelector('title').innerHTML = 'MijnDP - Gebruikers';
    }

    render() {
        return (
            <div>
    
                <div className="card__header">
                  <h1>Mijn Gebruikers</h1>
                </div>

                <div className="card__body">
                    <div className="card__content">
                        <ReactTable
                              data={this.props.user.childUsers}
                              columns={this.columns}
                              defaultPageSize={10}
                              previousText="Vorige"
                              nextText='Volgende'
                              loadingText='Laden...'
                              noDataText='Geen data gevonden'
                              pageText='Pagina'
                              ofText='van'
                              rowsText='rijen'
                            />
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps (state) {
    return {
        user: state.UserReducer,
    }
}

export default withRouter(connect(mapStateToProps)(UserOverview));



// WEBPACK FOOTER //
// ./src/components/User/Overview/index.js